/**
 * Imports
 */
import { styled } from 'theme';
import {
  alignItems,
  AlignItemsProps,
  alignSelf,
  AlignSelfProps,
  border,
  BorderProps,
  color,
  ColorProps,
  flexbox,
  flexDirection,
  FlexDirectionProps,
  FlexProps,
  fontFamily,
  flexGrow,
  flexWrap,
  FlexWrapProps,
  FlexGrowProps,
  FontFamilyProps,
  justifyContent,
  JustifyContentProps,
  layout,
  LayoutProps,
  space,
  SpaceProps,
} from 'styled-system';

/**
 * Types
 */

type BoxProps = BorderProps &
  FlexDirectionProps &
  FlexProps &
  FlexGrowProps &
  FlexWrapProps &
  LayoutProps &
  SpaceProps &
  AlignItemsProps &
  JustifyContentProps &
  ColorProps &
  FontFamilyProps &
  AlignSelfProps;

/**
 * Styling
 */
const Box = styled.div<BoxProps>`
  ${border}
  ${color}
  ${flexbox}
  ${flexGrow}
  ${flexWrap}
  ${flexDirection}
  ${alignItems}
  ${alignSelf}
  ${fontFamily}
  ${justifyContent}
  ${space}
  ${layout}
`;

/**
 * Exports
 */
export { Box };
